/* eslint-disable no-use-before-define */
import React, { useEffect, useState } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import citiesData from "../data/CitiesAtom.json";
import { makeStyles } from "@material-ui/core/styles";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { DatePicker } from "@material-ui/pickers";
import InputLabel from "@material-ui/core/InputLabel";
// import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
// import Popover from "@material-ui/core/Popover";
import Select from "@material-ui/core/Select";
import Fab from "@material-ui/core/Fab";
import SearchIcon from "@material-ui/icons/Search";
// import Button from "@material-ui/core/Button";
import deLocale from "date-fns/locale/es";
import { addDays } from "date-fns";
import { addMonths } from "date-fns/esm";
import Box from "@material-ui/core/Box";
import Alert from "@material-ui/lab/Alert";
// import {  subDays } from 'date-fns'

//import 'https://atom.travel/css/thumbnail-gallery.css';

export default function SearchHotels(props) {
  const [noches, setNoches] = useState(1);
  const [cities, setCities] = useState(
    citiesData.filter(({ name }) => name.indexOf("Miami") > -1)
  );
  const [search, setSearch] = useState("");
  const [citySelected, setCitySelected] = React.useState("");
  const [dateFrom, setDateFrom] = React.useState(
    addMonths(new Date(Date.now()), 1)
  );
  const [dateTo, setDateTo] = React.useState(addDays(dateFrom, noches));

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [searchA, setsearchA] = useState({});
  const [firstSearchA, setfirstSearchA] = useState(false);
  const [cantHab, setCantHab] = useState(1);
  const [h1Adultos, setH1Adultos] = useState(2);
  const [h2Adultos, setH2Adultos] = useState(0);
  const [h3Adultos, setH3Adultos] = useState(0);
  const [h1Ninos, setH1Ninos] = useState(0);
  const [h2Ninos, setH2Ninos] = useState(0);
  const [h3Ninos, setH3Ninos] = useState(0);
  const [h1E1, setH1E1] = useState(5);
  const [h1E2, setH1E2] = useState(5);
  const [h1E3, setH1E3] = useState(5);
  const [h2E1, setH2E1] = useState(5);
  const [h2E2, setH2E2] = useState(5);
  const [h2E3, setH2E3] = useState(5);
  const [h3E1, setH3E1] = useState(5);
  const [h3E2, setH3E2] = useState(5);
  const [h3E3, setH3E3] = useState(5);
  const [flagCriterio, setFlagCriterio] = useState(false);
  const [criterioMensaje, setCriterioMensaje] = useState("");

  const handleChangeCantHab = (event) => {
    setCantHab(event.target.value);
  };

  //HABITACION 1
  const HandleChangeH1Adultos = (event) => {
    setH1Adultos(event.target.value);
  };
  const HandleChangeH1Ninos = (event) => {
    setH1Ninos(event.target.value);
  };
  const handleChangeH1E1 = (event) => {
    setH1E1(event.target.value);
  };
  const handleChangeH1E2 = (event) => {
    setH1E2(event.target.value);
  };
  const handleChangeH1E3 = (event) => {
    setH1E3(event.target.value);
  };

  //HABITACION 2
  const HandleChangeH2Adultos = (event) => {
    setH2Adultos(event.target.value);
  };
  const HandleChangeH2Ninos = (event) => {
    setH2Ninos(event.target.value);
  };
  const handleChangeH2E1 = (event) => {
    setH2E1(event.target.value);
  };
  const handleChangeH2E2 = (event) => {
    setH2E2(event.target.value);
  };
  const handleChangeH2E3 = (event) => {
    setH2E3(event.target.value);
  };

  //HABITACION 3
  const HandleChangeH3Adultos = (event) => {
    setH3Adultos(event.target.value);
  };
  const HandleChangeH3Ninos = (event) => {
    setH3Ninos(event.target.value);
  };
  const handleChangeH3E1 = (event) => {
    setH3E1(event.target.value);
  };
  const handleChangeH3E2 = (event) => {
    setH3E2(event.target.value);
  };
  const handleChangeH3E3 = (event) => {
    setH3E3(event.target.value);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  /*     const handleDateChange = (date) => {
            setSelectedDate(date);
        }; */

  useEffect(() => {
    var pepe = [];
    if (search !== "" && search.length >= 3) {
      pepe = citiesData.filter(
        ({ synonymous }) =>
          synonymous.toLowerCase().indexOf(search.toLowerCase()) > -1
      );
    }
    setCities(pepe);
    setFlagCriterio(false);
  }, [search]);

  useEffect(() => {
    /*   if (dateTo <= dateFrom) {
      setDateTo(addDays(dateFrom, 10));
    } */
    setFlagCriterio(false);
  }, [dateFrom, dateTo]);

  useEffect(() => {
    if (firstSearchA) {
      props.onClick(searchA);
    }
  }, [searchA]);

  const onChangeHandler = (event) => {
    setSearch(event.target.value);
  };

  const onChangeHandlerSelect = (event) => {
    console.log("pepe");
    console.log(event.target.value);
    var pepe = [];
    
    pepe = citiesData.find((pp) => pp.code === event.target.value);

    // setSearch(event.target.value);
    setCitySelected(pepe);
    console.log(pepe);
  };

  const onChangeNoches = (event) => {
    setNoches(event.target.value);
    setDateTo(addDays(dateFrom, event.target.value));
  };

  const onChangeDateFrom = (event) => {
    setDateFrom(event);
    setDateTo(addDays(event, noches));
  };

  const onChangeDateTo = (event) => {
    if (event <= dateFrom) {
      alert("La fecha fin no puede ser anterior a la fecha de inicio.");
    } else {
      setDateTo(event);
      var timeDiff = Math.abs(event.getTime() - dateFrom.getTime());
      var numberOfNights = Math.ceil(timeDiff / (1000 * 3600 * 24));
      setNoches(numberOfNights);
    }
  };

  const useStyles = makeStyles({
    option: {
      fontSize: 15,
      "& > span": {
        marginRight: 10,
        fontSize: 18,
      },
      backgroundColor: "#eceff1",
    },
    card: {
      width: "100%",
      maxWidth: "1165px",
      backgroundColor: "#016AA2",
    },
    cardRooms: {
      width: "100%",
      maxWidth: "1165px",
      backgroundColor: "white",
    },
    buttonFilter: {
      background: "#FE5215",
      color: "white",
      fontFamily: "MontserratSemiBold",
      textTransform: "capitalize",
      "&:hover": {
        background: "#016AA2",
        color: "white",
      },
    },
    TituloBuscador: {
      color: "white",
    },
  });

  const defaultProps = {
    bgcolor: "background.paper",
    borderColor: "#016AA2",
    m: 1,
    border: 1,
  };

  var rand = function () {
    return Math.random().toString(36).substr(2); // remove `0.`
  };

  function toTimestamp(strDate) {
    var datum = Date.parse(strDate);
    return datum / 1000;
  }

  const handleDateChangeRaw = (e) => {
    e.preventDefault();
  };

  const SearchHotels = (e) => {
    
    var citySelectedAux = "";
    if (citySelected === ""){
      var pepe = [];
      citySelectedAux = citiesData.find((pp) => pp.code === "ORL");
      setCitySelected(pepe); 
    } else {
      citySelectedAux = citySelected;
    }

    console.log(citySelectedAux);
    const from = new Date(dateFrom);
    const to = new Date(dateTo);
    var i;
    var habdistri = "";
    for (i = 0; i < 3; i++) {
      switch (i) {
        case 0:
          habdistri = "hab1=" + h1Adultos + "," + h1Ninos;
          var j;
          for (j = 0; j < h1Ninos; j++) {
            switch (j) {
              case 0:
                habdistri = habdistri + "," + h1E1;
                break;
              case 1:
                habdistri = habdistri + "," + h1E2;
                break;
              case 2:
                habdistri = habdistri + "," + h1E3;
                break;
              default:
            }
          }
          break;
        // case 1:
        //   if (h2Adultos !== 0) {
        //     habdistri = habdistri + "&hab2=" + h2Adultos + "," + h2Ninos;
        //     var j1;
        //     for (j1 = 0; j1 < h2Ninos; j1++) {
        //       switch (j1) {
        //         case 0:
        //           habdistri = habdistri + "," + h2E1;
        //           break;
        //         case 1:
        //           habdistri = habdistri + "," + h2E2;
        //           break;
        //         case 2:
        //           habdistri = habdistri + "," + h2E3;
        //           break;
        //         default:
        //       }
        //     }
        //   } else {
        //     habdistri = habdistri + "&hab2=0";
        //   }

        //   break;
        // case 2:
        //   if (h3Adultos !== 0) {
        //     habdistri = habdistri + "&hab3=" + h3Adultos + "," + h3Ninos;
        //     var j2;
        //     for (j2 = 0; j2 < h3Ninos; j2++) {
        //       switch (j2) {
        //         case 0:
        //           habdistri = habdistri + "," + h3E1;
        //           break;
        //         case 1:
        //           habdistri = habdistri + "," + h3E2;
        //           break;
        //         case 2:
        //           habdistri = habdistri + "," + h3E3;
        //           break;
        //         default:
        //       }
        //     }
        //   } else {
        //     habdistri = habdistri + "&hab3=0";
        //   }
        //   break;
        default:
      }
    }
    /*  console.log(habdistri);
    console.log("citySelected.code");
    console.log(citySelected.code);
    console.log(from)
    console.log(to)
    console.log(from >= to) */
    if (typeof citySelectedAux.code !== "undefined") {
      if (from <= to) {
        setFlagCriterio(false);
        const searchObject = {
          SearchToken: rand() + rand() + toTimestamp(Date()),
          city: citySelectedAux.code,
          zoneName: citySelectedAux.name + ", " + citySelectedAux.country_name,
          countryFlag: "/Images/Flags/" + citySelectedAux.country_code + ".png",
          from:
            from.getFullYear() +
            "" +
            ("0" + (from.getMonth() + 1)).slice(-2) +
            "" +
            ("0" + from.getDate()).slice(-2),
          to:
            to.getFullYear() +
            "" +
            ("0" + (to.getMonth() + 1)).slice(-2) +
            "" +
            ("0" + to.getDate()).slice(-2),
          distribution: habdistri,
        };
        setfirstSearchA(true);
        setsearchA(searchObject);
      } else {
        setCriterioMensaje(
          "La fecha fin debe ser superior a la fecha de inicio."
        );
        setFlagCriterio(true);
      }
    } else {
      setCriterioMensaje("Favor indica la zona de busqueda.");
      setFlagCriterio(true);
    }
  };

  const classes = useStyles();
  return (
    <React.Fragment>
      {/* <div style={{ width: 300 }}> */}
      <Card className={classes.card} variant="outlined">
        <CardContent className={classes.Container}>
          <Typography
            component={"div"}
            variant="h6"
            gutterBottom
            className={classes.TituloBuscador}
            style={{ fontFamily: "MontserratSemiBold" }}
          >
            Busca los mejores precios en servicios
          </Typography>
          <Box borderRadius="borderRadius" {...defaultProps}>
            <Grid container justify="space-around">
              <Grid item xs={4}
                 style={{ marginTop: "16px", marginBottom: "8px" }}
              >
                <FormControl className={classes.formControlSmall}  style={{ width: "100%" }}>
                  <InputLabel
                    shrink
                    id="demo-simple-select-placeholder-label-label"
                  >
                    Favor indique el destino deseado
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-placeholder-label-label"
                    id="demo-simple-select-placeholder-label"
                    defaultValue={"ORL"}
                    //value={citySelected}
                    // onChange={HandleChangeH1Adultos}
                    onChange={onChangeHandlerSelect}
                    label="Seleccione su destino"
                    displayEmpty
                    className={classes.selectEmpty}
                  >
                    <MenuItem value={"MIA"}>Miami</MenuItem>
                    <MenuItem value={"ORL"}>Orlando</MenuItem>
                  </Select>
                </FormControl>
                {/* <Autocomplete
                  id="free-solo-2-demo"
                  freeSolo
                  disableClearable
                  options={cities}
                  // onChange={(event) => {
                  //     console.log('evento ' + event.target.value);
                  // }}
                  value={citySelected}
                  defaultValue={citySelected.name}
                  onChange={(event, newValue) => {
                    setCitySelected(newValue);
                  }}
                  classes={{
                    option: classes.option,
                  }}
                  getOptionLabel={(option) => option.name}
                  renderOption={(option) => (
                    <React.Fragment>
                      <span style={{ verticalAlign: "baseline" }}>
                        <img
                          src={"/Images/Flags/" + option.country_code + ".png"}
                          alt="Banderas"
                        ></img>
                      </span>
                      {option.name}, {option.country_name}
                    </React.Fragment>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Indique destino"
                      margin="normal"
                      // variant="outlined"
                      value={search}
                      onChange={onChangeHandler}
                      InputProps={{ ...params.InputProps, type: "search" }}
                    />
                  )}
                /> */}
              </Grid>

              <Grid item xs={2}>
                <MuiPickersUtilsProvider
                  locale={deLocale}
                  utils={DateFnsUtils}
                  className={"notranslate"}
                >
                  <DatePicker
                    disableToolbar
                    variant="inline"
                    label="Fecha desde"
                    format="dd/MM/yyyy"
                    margin="normal"
                    id="dateFrom"
                    value={dateFrom}
                    onChange={onChangeDateFrom}
                    autoOk="true"
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              {/* <Grid
                item
                xs={1}
                style={{ marginTop: "16px", marginBottom: "8px" }}
              >
                <TextField
                  id="standard-number"
                  label="Noches"
                  type="number"
                  onChange={onChangeNoches}
                  value={noches}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid> */}
              <Grid item xs={2}>
                <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
                  <DatePicker
                    disableToolbar
                    variant="inline"
                    label="Fecha hasta"
                    format="dd/MM/yyyy"
                    margin="normal"
                    id="dateTo"
                    value={dateTo}
                    onChange={onChangeDateTo}
                    autoOk="true"
                  />
                </MuiPickersUtilsProvider>
              </Grid>

              {/* COLOCADO PARA SOLO TRABAJAR CON UNA SOLA HABITACION */}
              <Grid item xs={2}>
                <Grid
                  item
                  xs={12}
                  container
                  justify="space-around"
                  style={{ marginTop: "16px", marginBottom: "8px" }}
                >
                  <Grid item xs={3}>
                    <FormControl className={classes.formControlSmall}>
                      <InputLabel
                        shrink
                        id="demo-simple-select-placeholder-label-label"
                      >
                        Adultos
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-placeholder-label-label"
                        id="demo-simple-select-placeholder-label"
                        value={h1Adultos}
                        onChange={HandleChangeH1Adultos}
                        displayEmpty
                        className={classes.selectEmpty}
                      >
                        <MenuItem value={1}>1</MenuItem>
                        <MenuItem value={2}>2</MenuItem>
                        <MenuItem value={3}>3</MenuItem>
                        <MenuItem value={4}>4</MenuItem>
                        <MenuItem value={5}>5</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={3}>
                    <FormControl className={classes.formControlSmall}>
                      <InputLabel
                        shrink
                        id="demo-simple-select-placeholder-label-label"
                      >
                        Niños
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-placeholder-label-label"
                        id="demo-simple-select-placeholder-label"
                        value={h1Ninos}
                        onChange={HandleChangeH1Ninos}
                        displayEmpty
                        className={classes.selectEmpty}
                      >
                        <MenuItem value={0}>0</MenuItem>
                        <MenuItem value={1}>1</MenuItem>
                        <MenuItem value={2}>2</MenuItem>
                        <MenuItem value={3}>3</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={2}>
                    {h1Ninos >= 1 ? (
                      <FormControl className={classes.formControlSmall}>
                        <InputLabel
                          shrink
                          id="demo-simple-select-placeholder-label-label"
                        >
                          Edad
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-placeholder-label-label"
                          id="demo-simple-select-placeholder-label"
                          value={h1E1}
                          onChange={handleChangeH1E1}
                          displayEmpty
                          className={classes.selectEmpty}
                        >
                          <MenuItem value={0}>0</MenuItem>
                          <MenuItem value={1}>1</MenuItem>
                          <MenuItem value={2}>2</MenuItem>
                          <MenuItem value={3}>3</MenuItem>
                          <MenuItem value={4}>4</MenuItem>
                          <MenuItem value={5}>5</MenuItem>
                          <MenuItem value={6}>6</MenuItem>
                          <MenuItem value={7}>7</MenuItem>
                          <MenuItem value={8}>8</MenuItem>
                          <MenuItem value={9}>9</MenuItem>
                          <MenuItem value={10}>10</MenuItem>
                          <MenuItem value={11}>11</MenuItem>
                          <MenuItem value={12}>12</MenuItem>
                          <MenuItem value={13}>13</MenuItem>
                          <MenuItem value={14}>14</MenuItem>
                          <MenuItem value={15}>15</MenuItem>
                          <MenuItem value={16}>16</MenuItem>
                          <MenuItem value={17}>17</MenuItem>
                          <MenuItem value={18}>18</MenuItem>
                        </Select>
                      </FormControl>
                    ) : (
                      <div></div>
                    )}
                    {h1Ninos >= 2 ? (
                      <FormControl className={classes.formControlSmall}>
                        <InputLabel
                          shrink
                          id="demo-simple-select-placeholder-label-label"
                        >
                          Edad
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-placeholder-label-label"
                          id="demo-simple-select-placeholder-label"
                          value={h1E2}
                          onChange={handleChangeH1E2}
                          displayEmpty
                          className={classes.selectEmpty}
                        >
                          <MenuItem value={0}>0</MenuItem>
                          <MenuItem value={1}>1</MenuItem>
                          <MenuItem value={2}>2</MenuItem>
                          <MenuItem value={3}>3</MenuItem>
                          <MenuItem value={4}>4</MenuItem>
                          <MenuItem value={5}>5</MenuItem>
                          <MenuItem value={6}>6</MenuItem>
                          <MenuItem value={7}>7</MenuItem>
                          <MenuItem value={8}>8</MenuItem>
                          <MenuItem value={9}>9</MenuItem>
                          <MenuItem value={10}>10</MenuItem>
                          <MenuItem value={11}>11</MenuItem>
                          <MenuItem value={12}>12</MenuItem>
                          <MenuItem value={13}>13</MenuItem>
                          <MenuItem value={14}>14</MenuItem>
                          <MenuItem value={15}>15</MenuItem>
                          <MenuItem value={16}>16</MenuItem>
                          <MenuItem value={17}>17</MenuItem>
                          <MenuItem value={18}>18</MenuItem>
                        </Select>
                      </FormControl>
                    ) : (
                      <div></div>
                    )}
                    {h1Ninos >= 3 ? (
                      <FormControl className={classes.formControlSmall}>
                        <InputLabel
                          shrink
                          id="demo-simple-select-placeholder-label-label"
                        >
                          Edad
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-placeholder-label-label"
                          id="demo-simple-select-placeholder-label"
                          value={h1E3}
                          onChange={handleChangeH1E3}
                          displayEmpty
                          className={classes.selectEmpty}
                        >
                          <MenuItem value={0}>0</MenuItem>
                          <MenuItem value={1}>1</MenuItem>
                          <MenuItem value={2}>2</MenuItem>
                          <MenuItem value={3}>3</MenuItem>
                          <MenuItem value={4}>4</MenuItem>
                          <MenuItem value={5}>5</MenuItem>
                          <MenuItem value={6}>6</MenuItem>
                          <MenuItem value={7}>7</MenuItem>
                          <MenuItem value={8}>8</MenuItem>
                          <MenuItem value={9}>9</MenuItem>
                          <MenuItem value={10}>10</MenuItem>
                          <MenuItem value={11}>11</MenuItem>
                          <MenuItem value={12}>12</MenuItem>
                          <MenuItem value={13}>13</MenuItem>
                          <MenuItem value={14}>14</MenuItem>
                          <MenuItem value={15}>15</MenuItem>
                          <MenuItem value={16}>16</MenuItem>
                          <MenuItem value={17}>17</MenuItem>
                          <MenuItem value={18}>18</MenuItem>
                        </Select>
                      </FormControl>
                    ) : (
                      <div></div>
                    )}
                  </Grid>
                </Grid>
              </Grid>

              {/* EN COMENTARIO PARA PODER MANEJAR SOLO UNA HABITACIÓN */}
              {/*  <Grid item xs={2}>
                <FormControl margin="normal">
                  <TextField
                    id="standard-basic"
                    label="Habitaciones"
                    onClick={handleClick}
                    value="1 Hab."
                  />
                  <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "center",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "center",
                    }}
                  >
                    <React.Fragment>
                      <Card className={classes.cardRooms}>
                        <CardContent className={classes.Container}>
                          <Grid container>
                            <Grid item xs={10}>
                              <Typography variant="subtitle1">
                                Cantidad habitaciones
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <FormControl className={classes.formControl}>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  value={cantHab}
                                  onChange={handleChangeCantHab}
                                >
                                  <MenuItem value={1}>1</MenuItem>
                                  <MenuItem value={2}>2</MenuItem>
                                  <MenuItem value={3}>3</MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>
                          </Grid>
                        </CardContent>
                        <CardContent>
                          <Grid container spacing={0}>
                            <Grid item xs={4}>
                              <FormControl>
                                <Typography variant="caption">
                                  Habitación 1
                                </Typography>
                              </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                              <FormControl className={classes.formControlSmall}>
                                <InputLabel
                                  shrink
                                  id="demo-simple-select-placeholder-label-label"
                                >
                                  Adultos
                                </InputLabel>
                                <Select
                                  labelId="demo-simple-select-placeholder-label-label"
                                  id="demo-simple-select-placeholder-label"
                                  value={h1Adultos}
                                  onChange={HandleChangeH1Adultos}
                                  displayEmpty
                                  className={classes.selectEmpty}
                                >
                                  <MenuItem value={1}>1</MenuItem>
                                  <MenuItem value={2}>2</MenuItem>
                                  <MenuItem value={3}>3</MenuItem>
                                  <MenuItem value={4}>4</MenuItem>
                                  <MenuItem value={5}>5</MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                              <FormControl className={classes.formControlSmall}>
                                <InputLabel
                                  shrink
                                  id="demo-simple-select-placeholder-label-label"
                                >
                                  Niños
                                </InputLabel>
                                <Select
                                  labelId="demo-simple-select-placeholder-label-label"
                                  id="demo-simple-select-placeholder-label"
                                  value={h1Ninos}
                                  onChange={HandleChangeH1Ninos}
                                  displayEmpty
                                  className={classes.selectEmpty}
                                >
                                  <MenuItem value={0}>0</MenuItem>
                                  <MenuItem value={1}>1</MenuItem>
                                  <MenuItem value={2}>2</MenuItem>
                                  <MenuItem value={3}>3</MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item xs={2}>
                              {h1Ninos >= 1 ? (
                                <FormControl
                                  className={classes.formControlSmall}
                                >
                                  <InputLabel
                                    shrink
                                    id="demo-simple-select-placeholder-label-label"
                                  >
                                    Edad
                                  </InputLabel>
                                  <Select
                                    labelId="demo-simple-select-placeholder-label-label"
                                    id="demo-simple-select-placeholder-label"
                                    value={h1E1}
                                    onChange={handleChangeH1E1}
                                    displayEmpty
                                    className={classes.selectEmpty}
                                  >
                                    <MenuItem value={0}>0</MenuItem>
                                    <MenuItem value={1}>1</MenuItem>
                                    <MenuItem value={2}>2</MenuItem>
                                    <MenuItem value={3}>3</MenuItem>
                                    <MenuItem value={4}>4</MenuItem>
                                    <MenuItem value={5}>5</MenuItem>
                                    <MenuItem value={6}>6</MenuItem>
                                    <MenuItem value={7}>7</MenuItem>
                                    <MenuItem value={8}>8</MenuItem>
                                    <MenuItem value={9}>9</MenuItem>
                                    <MenuItem value={10}>10</MenuItem>
                                    <MenuItem value={11}>11</MenuItem>
                                    <MenuItem value={12}>12</MenuItem>
                                    <MenuItem value={13}>13</MenuItem>
                                    <MenuItem value={14}>14</MenuItem>
                                    <MenuItem value={15}>15</MenuItem>
                                    <MenuItem value={16}>16</MenuItem>
                                    <MenuItem value={17}>17</MenuItem>
                                    <MenuItem value={18}>18</MenuItem>
                                  </Select>
                                </FormControl>
                              ) : (
                                <div></div>
                              )}
                              {h1Ninos >= 2 ? (
                                <FormControl
                                  className={classes.formControlSmall}
                                >
                                  <InputLabel
                                    shrink
                                    id="demo-simple-select-placeholder-label-label"
                                  >
                                    Edad
                                  </InputLabel>
                                  <Select
                                    labelId="demo-simple-select-placeholder-label-label"
                                    id="demo-simple-select-placeholder-label"
                                    value={h1E2}
                                    onChange={handleChangeH1E2}
                                    displayEmpty
                                    className={classes.selectEmpty}
                                  >
                                    <MenuItem value={0}>0</MenuItem>
                                    <MenuItem value={1}>1</MenuItem>
                                    <MenuItem value={2}>2</MenuItem>
                                    <MenuItem value={3}>3</MenuItem>
                                    <MenuItem value={4}>4</MenuItem>
                                    <MenuItem value={5}>5</MenuItem>
                                    <MenuItem value={6}>6</MenuItem>
                                    <MenuItem value={7}>7</MenuItem>
                                    <MenuItem value={8}>8</MenuItem>
                                    <MenuItem value={9}>9</MenuItem>
                                    <MenuItem value={10}>10</MenuItem>
                                    <MenuItem value={11}>11</MenuItem>
                                    <MenuItem value={12}>12</MenuItem>
                                    <MenuItem value={13}>13</MenuItem>
                                    <MenuItem value={14}>14</MenuItem>
                                    <MenuItem value={15}>15</MenuItem>
                                    <MenuItem value={16}>16</MenuItem>
                                    <MenuItem value={17}>17</MenuItem>
                                    <MenuItem value={18}>18</MenuItem>
                                  </Select>
                                </FormControl>
                              ) : (
                                <div></div>
                              )}
                              {h1Ninos >= 3 ? (
                                <FormControl
                                  className={classes.formControlSmall}
                                >
                                  <InputLabel
                                    shrink
                                    id="demo-simple-select-placeholder-label-label"
                                  >
                                    Edad
                                  </InputLabel>
                                  <Select
                                    labelId="demo-simple-select-placeholder-label-label"
                                    id="demo-simple-select-placeholder-label"
                                    value={h1E3}
                                    onChange={handleChangeH1E3}
                                    displayEmpty
                                    className={classes.selectEmpty}
                                  >
                                    <MenuItem value={0}>0</MenuItem>
                                    <MenuItem value={1}>1</MenuItem>
                                    <MenuItem value={2}>2</MenuItem>
                                    <MenuItem value={3}>3</MenuItem>
                                    <MenuItem value={4}>4</MenuItem>
                                    <MenuItem value={5}>5</MenuItem>
                                    <MenuItem value={6}>6</MenuItem>
                                    <MenuItem value={7}>7</MenuItem>
                                    <MenuItem value={8}>8</MenuItem>
                                    <MenuItem value={9}>9</MenuItem>
                                    <MenuItem value={10}>10</MenuItem>
                                    <MenuItem value={11}>11</MenuItem>
                                    <MenuItem value={12}>12</MenuItem>
                                    <MenuItem value={13}>13</MenuItem>
                                    <MenuItem value={14}>14</MenuItem>
                                    <MenuItem value={15}>15</MenuItem>
                                    <MenuItem value={16}>16</MenuItem>
                                    <MenuItem value={17}>17</MenuItem>
                                    <MenuItem value={18}>18</MenuItem>
                                  </Select>
                                </FormControl>
                              ) : (
                                <div></div>
                              )}
                            </Grid>
                          </Grid>
                          <Divider variant="middle" />
                        </CardContent>
                        {cantHab >= 2 ? (
                          <CardContent>
                            <Grid container spacing={0}>
                              <Grid item xs={4}>
                                <FormControl>
                                  <Typography variant="caption">
                                    Habitación 2
                                  </Typography>
                                </FormControl>
                              </Grid>
                              <Grid item xs={3}>
                                <FormControl
                                  className={classes.formControlSmall}
                                >
                                  <InputLabel
                                    shrink
                                    id="demo-simple-select-placeholder-label-label"
                                  >
                                    Adultos
                                  </InputLabel>
                                  <Select
                                    labelId="demo-simple-select-placeholder-label-label"
                                    id="demo-simple-select-placeholder-label"
                                    value={h2Adultos}
                                    onChange={HandleChangeH2Adultos}
                                    displayEmpty
                                    className={classes.selectEmpty}
                                  >
                                    <MenuItem value={1}>1</MenuItem>
                                    <MenuItem value={2}>2</MenuItem>
                                    <MenuItem value={3}>3</MenuItem>
                                    <MenuItem value={4}>4</MenuItem>
                                    <MenuItem value={5}>5</MenuItem>
                                  </Select>
                                </FormControl>
                              </Grid>
                              <Grid item xs={3}>
                                <FormControl
                                  className={classes.formControlSmall}
                                >
                                  <InputLabel
                                    shrink
                                    id="demo-simple-select-placeholder-label-label"
                                  >
                                    Niños
                                  </InputLabel>
                                  <Select
                                    labelId="demo-simple-select-placeholder-label-label"
                                    id="demo-simple-select-placeholder-label"
                                    value={h2Ninos}
                                    onChange={HandleChangeH2Ninos}
                                    displayEmpty
                                    className={classes.selectEmpty}
                                  >
                                    <MenuItem value={0}>0</MenuItem>
                                    <MenuItem value={1}>1</MenuItem>
                                    <MenuItem value={2}>2</MenuItem>
                                    <MenuItem value={3}>3</MenuItem>
                                  </Select>
                                </FormControl>
                              </Grid>
                              <Grid item xs={2}>
                                {h2Ninos >= 1 ? (
                                  <FormControl
                                    className={classes.formControlSmall}
                                  >
                                    <InputLabel
                                      shrink
                                      id="demo-simple-select-placeholder-label-label"
                                    >
                                      Edad
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-placeholder-label-label"
                                      id="demo-simple-select-placeholder-label"
                                      value={h2E1}
                                      onChange={handleChangeH2E1}
                                      displayEmpty
                                      className={classes.selectEmpty}
                                    >
                                      <MenuItem value={0}>0</MenuItem>
                                      <MenuItem value={1}>1</MenuItem>
                                      <MenuItem value={2}>2</MenuItem>
                                      <MenuItem value={3}>3</MenuItem>
                                      <MenuItem value={4}>4</MenuItem>
                                      <MenuItem value={5}>5</MenuItem>
                                      <MenuItem value={6}>6</MenuItem>
                                      <MenuItem value={7}>7</MenuItem>
                                      <MenuItem value={8}>8</MenuItem>
                                      <MenuItem value={9}>9</MenuItem>
                                      <MenuItem value={10}>10</MenuItem>
                                      <MenuItem value={11}>11</MenuItem>
                                      <MenuItem value={12}>12</MenuItem>
                                      <MenuItem value={13}>13</MenuItem>
                                      <MenuItem value={14}>14</MenuItem>
                                      <MenuItem value={15}>15</MenuItem>
                                      <MenuItem value={16}>16</MenuItem>
                                      <MenuItem value={17}>17</MenuItem>
                                      <MenuItem value={18}>18</MenuItem>
                                    </Select>
                                  </FormControl>
                                ) : (
                                  <div></div>
                                )}
                                {h2Ninos >= 2 ? (
                                  <FormControl
                                    className={classes.formControlSmall}
                                  >
                                    <InputLabel
                                      shrink
                                      id="demo-simple-select-placeholder-label-label"
                                    >
                                      Edad
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-placeholder-label-label"
                                      id="demo-simple-select-placeholder-label"
                                      value={h2E2}
                                      onChange={handleChangeH2E2}
                                      displayEmpty
                                      className={classes.selectEmpty}
                                    >
                                      <MenuItem value={0}>0</MenuItem>
                                      <MenuItem value={1}>1</MenuItem>
                                      <MenuItem value={2}>2</MenuItem>
                                      <MenuItem value={3}>3</MenuItem>
                                      <MenuItem value={4}>4</MenuItem>
                                      <MenuItem value={5}>5</MenuItem>
                                      <MenuItem value={6}>6</MenuItem>
                                      <MenuItem value={7}>7</MenuItem>
                                      <MenuItem value={8}>8</MenuItem>
                                      <MenuItem value={9}>9</MenuItem>
                                      <MenuItem value={10}>10</MenuItem>
                                      <MenuItem value={11}>11</MenuItem>
                                      <MenuItem value={12}>12</MenuItem>
                                      <MenuItem value={13}>13</MenuItem>
                                      <MenuItem value={14}>14</MenuItem>
                                      <MenuItem value={15}>15</MenuItem>
                                      <MenuItem value={16}>16</MenuItem>
                                      <MenuItem value={17}>17</MenuItem>
                                      <MenuItem value={18}>18</MenuItem>
                                    </Select>
                                  </FormControl>
                                ) : (
                                  <div></div>
                                )}
                                {h2Ninos >= 3 ? (
                                  <FormControl
                                    className={classes.formControlSmall}
                                  >
                                    <InputLabel
                                      shrink
                                      id="demo-simple-select-placeholder-label-label"
                                    >
                                      Edad
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-placeholder-label-label"
                                      id="demo-simple-select-placeholder-label"
                                      value={h2E3}
                                      onChange={handleChangeH2E3}
                                      displayEmpty
                                      className={classes.selectEmpty}
                                    >
                                      <MenuItem value={0}>0</MenuItem>
                                      <MenuItem value={1}>1</MenuItem>
                                      <MenuItem value={2}>2</MenuItem>
                                      <MenuItem value={3}>3</MenuItem>
                                      <MenuItem value={4}>4</MenuItem>
                                      <MenuItem value={5}>5</MenuItem>
                                      <MenuItem value={6}>6</MenuItem>
                                      <MenuItem value={7}>7</MenuItem>
                                      <MenuItem value={8}>8</MenuItem>
                                      <MenuItem value={9}>9</MenuItem>
                                      <MenuItem value={10}>10</MenuItem>
                                      <MenuItem value={11}>11</MenuItem>
                                      <MenuItem value={12}>12</MenuItem>
                                      <MenuItem value={13}>13</MenuItem>
                                      <MenuItem value={14}>14</MenuItem>
                                      <MenuItem value={15}>15</MenuItem>
                                      <MenuItem value={16}>16</MenuItem>
                                      <MenuItem value={17}>17</MenuItem>
                                      <MenuItem value={18}>18</MenuItem>
                                    </Select>
                                  </FormControl>
                                ) : (
                                  <div></div>
                                )}
                              </Grid>
                            </Grid>
                            <Divider variant="middle" />
                          </CardContent>
                        ) : (
                          <div></div>
                        )}
                        {cantHab >= 3 ? (
                          <CardContent>
                            <Grid container spacing={0}>
                              <Grid item xs={4}>
                                <FormControl>
                                  <Typography variant="caption">
                                    Habitación 3
                                  </Typography>
                                </FormControl>
                              </Grid>
                              <Grid item xs={3}>
                                <FormControl
                                  className={classes.formControlSmall}
                                >
                                  <InputLabel
                                    shrink
                                    id="demo-simple-select-placeholder-label-label"
                                  >
                                    Adultos
                                  </InputLabel>
                                  <Select
                                    labelId="demo-simple-select-placeholder-label-label"
                                    id="demo-simple-select-placeholder-label"
                                    value={h3Adultos}
                                    onChange={HandleChangeH3Adultos}
                                    displayEmpty
                                    className={classes.selectEmpty}
                                  >
                                    <MenuItem value={1}>1</MenuItem>
                                    <MenuItem value={2}>2</MenuItem>
                                    <MenuItem value={3}>3</MenuItem>
                                    <MenuItem value={4}>4</MenuItem>
                                    <MenuItem value={5}>5</MenuItem>
                                  </Select>
                                </FormControl>
                              </Grid>
                              <Grid item xs={3}>
                                <FormControl
                                  className={classes.formControlSmall}
                                >
                                  <InputLabel
                                    shrink
                                    id="demo-simple-select-placeholder-label-label"
                                  >
                                    Niños
                                  </InputLabel>
                                  <Select
                                    labelId="demo-simple-select-placeholder-label-label"
                                    id="demo-simple-select-placeholder-label"
                                    value={h3Ninos}
                                    onChange={HandleChangeH3Ninos}
                                    displayEmpty
                                    className={classes.selectEmpty}
                                  >
                                    <MenuItem value={0}>0</MenuItem>
                                    <MenuItem value={1}>1</MenuItem>
                                    <MenuItem value={2}>2</MenuItem>
                                    <MenuItem value={3}>3</MenuItem>
                                  </Select>
                                </FormControl>
                              </Grid>
                              <Grid item xs={2}>
                                {h3Ninos >= 1 ? (
                                  <FormControl
                                    className={classes.formControlSmall}
                                  >
                                    <InputLabel
                                      shrink
                                      id="demo-simple-select-placeholder-label-label"
                                    >
                                      Edad
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-placeholder-label-label"
                                      id="demo-simple-select-placeholder-label"
                                      value={h3E1}
                                      onChange={handleChangeH3E1}
                                      displayEmpty
                                      className={classes.selectEmpty}
                                    >
                                      <MenuItem value={0}>0</MenuItem>
                                      <MenuItem value={1}>1</MenuItem>
                                      <MenuItem value={2}>2</MenuItem>
                                      <MenuItem value={3}>3</MenuItem>
                                      <MenuItem value={4}>4</MenuItem>
                                      <MenuItem value={5}>5</MenuItem>
                                      <MenuItem value={6}>6</MenuItem>
                                      <MenuItem value={7}>7</MenuItem>
                                      <MenuItem value={8}>8</MenuItem>
                                      <MenuItem value={9}>9</MenuItem>
                                      <MenuItem value={10}>10</MenuItem>
                                      <MenuItem value={11}>11</MenuItem>
                                      <MenuItem value={12}>12</MenuItem>
                                      <MenuItem value={13}>13</MenuItem>
                                      <MenuItem value={14}>14</MenuItem>
                                      <MenuItem value={15}>15</MenuItem>
                                      <MenuItem value={16}>16</MenuItem>
                                      <MenuItem value={17}>17</MenuItem>
                                      <MenuItem value={18}>18</MenuItem>
                                    </Select>
                                  </FormControl>
                                ) : (
                                  <div></div>
                                )}
                                {h3Ninos >= 2 ? (
                                  <FormControl
                                    className={classes.formControlSmall}
                                  >
                                    <InputLabel
                                      shrink
                                      id="demo-simple-select-placeholder-label-label"
                                    >
                                      Edad
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-placeholder-label-label"
                                      id="demo-simple-select-placeholder-label"
                                      value={h3E2}
                                      onChange={handleChangeH3E2}
                                      displayEmpty
                                      className={classes.selectEmpty}
                                    >
                                      <MenuItem value={0}>0</MenuItem>
                                      <MenuItem value={1}>1</MenuItem>
                                      <MenuItem value={2}>2</MenuItem>
                                      <MenuItem value={3}>3</MenuItem>
                                      <MenuItem value={4}>4</MenuItem>
                                      <MenuItem value={5}>5</MenuItem>
                                      <MenuItem value={6}>6</MenuItem>
                                      <MenuItem value={7}>7</MenuItem>
                                      <MenuItem value={8}>8</MenuItem>
                                      <MenuItem value={9}>9</MenuItem>
                                      <MenuItem value={10}>10</MenuItem>
                                      <MenuItem value={11}>11</MenuItem>
                                      <MenuItem value={12}>12</MenuItem>
                                      <MenuItem value={13}>13</MenuItem>
                                      <MenuItem value={14}>14</MenuItem>
                                      <MenuItem value={15}>15</MenuItem>
                                      <MenuItem value={16}>16</MenuItem>
                                      <MenuItem value={17}>17</MenuItem>
                                      <MenuItem value={18}>18</MenuItem>
                                    </Select>
                                  </FormControl>
                                ) : (
                                  <div></div>
                                )}
                                {h3Ninos >= 3 ? (
                                  <FormControl
                                    className={classes.formControlSmall}
                                  >
                                    <InputLabel
                                      shrink
                                      id="demo-simple-select-placeholder-label-label"
                                    >
                                      Edad
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-placeholder-label-label"
                                      id="demo-simple-select-placeholder-label"
                                      value={h3E3}
                                      onChange={handleChangeH3E3}
                                      displayEmpty
                                      className={classes.selectEmpty}
                                    >
                                      <MenuItem value={0}>0</MenuItem>
                                      <MenuItem value={1}>1</MenuItem>
                                      <MenuItem value={2}>2</MenuItem>
                                      <MenuItem value={3}>3</MenuItem>
                                      <MenuItem value={4}>4</MenuItem>
                                      <MenuItem value={5}>5</MenuItem>
                                      <MenuItem value={6}>6</MenuItem>
                                      <MenuItem value={7}>7</MenuItem>
                                      <MenuItem value={8}>8</MenuItem>
                                      <MenuItem value={9}>9</MenuItem>
                                      <MenuItem value={10}>10</MenuItem>
                                      <MenuItem value={11}>11</MenuItem>
                                      <MenuItem value={12}>12</MenuItem>
                                      <MenuItem value={13}>13</MenuItem>
                                      <MenuItem value={14}>14</MenuItem>
                                      <MenuItem value={15}>15</MenuItem>
                                      <MenuItem value={16}>16</MenuItem>
                                      <MenuItem value={17}>17</MenuItem>
                                      <MenuItem value={18}>18</MenuItem>
                                    </Select>
                                  </FormControl>
                                ) : (
                                  <div></div>
                                )}
                              </Grid>
                            </Grid>
                            <Divider variant="middle" />
                          </CardContent>
                        ) : (
                          <div></div>
                        )}
                      </Card>
                    </React.Fragment>
                  </Popover>
                </FormControl>
              </Grid> */}
              <Grid item xs={1} container direction="row" justify="center">
                <FormControl margin="normal">
                  <Fab
                    size="medium"
                    variant="extended"
                    onClick={SearchHotels}
                    className={classes.buttonFilter}
                  >
                    <SearchIcon className={classes.extendedIcon} /> Buscar
                  </Fab>
                </FormControl>
              </Grid>
              {flagCriterio && (
                <Grid item xs={12} container direction="row" justify="center">
                  <Alert
                    severity="error"
                    style={{ width: "100%", margin: "7px" }}
                  >
                    {criterioMensaje}
                  </Alert>
                </Grid>
              )}
            </Grid>
          </Box>
        </CardContent>
      </Card>

      {/* </div> */}
    </React.Fragment>
  );
}
